import React from 'react';
import '../template-file-css/document-file-template.css';


export const BFCS_DischargeSummary = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='BFCS_DischargeSummary' className='file-pdf-document'>
            <div className='file-template'>
 
                <p className='w-750'>
                    <span className='eleHeader'>Presenting Condition </span>
                    <span className='small'>According to the “Presenting Condition”
                        section of the Psychosocial Assessment that was completed upon admission)
                    </span>
                    <textarea id="txt_1" name="txt_1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Extent to which goals and objectives were met </span>
                    <span className='small'>(According to the
                        individual plans and progress reviews that were completed during programming)
                    </span>
                    <textarea id="txt_2" name="txt_2" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Progress toward recovery or well-being </span>
                    <span className='small'>(This is based on a
                        review of functioning at admission, the participant's identified needs and goals, the level
                        of goal achievement, and the level of functioning at discharge as compared to the level of
                        functioning at admission)
                    </span>
                    <textarea id="txt_3" name="txt_3" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Gains achieved during program participation</span>
                    <span className='small'>(How did the
                        participant's life improve during program participation)
                    </span>
                    <textarea id="txt_4" name="txt_4" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Strengths, Needs, Abilities, Preferences </span>
                    <span className='small'>(Review this section of
                        the Psychosocial Assessment and compare to the participants functioning at discharge. What
                        changes have occurred in these areas as a result of program participation?)
                    </span>
                    <textarea id="txt_5" name="txt_5" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Services Provided </span>
                            <span className='small'>(These should be listed according to
                                the services listed in your program plans, program guides, marketing materials,
                                etc.)
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_6" name="cb_6" className='add-only' value="1" /> Psychiatric
                            Evaluation
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_7" name="cb_7" className='add-only' value="1" /> Treatment Planning
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_8" name="cb_8" className='add-only' value="1" /> Community
                            Psychiatric Supportive Treatment (CPST)
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_9" name="cb_9" className='add-only' value="1" /> Psycho-Social
                            Rehabilitation Services (PSR)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_10" name="cb_10" className='add-only' value="1" /> Medication
                            Management/ Education
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_11" name="cb_11" className='add-only' value="1" /> Crisis
                            Intervention
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_12" name="cb_12" className='add-only' value="1" /> Functional Family
                            Therapy (FFT)
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_13" name="cb_13" className='add-only' value="1" /> Homebuilders
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_14" name="cb_14" className='add-only' value="1" /> Multis-systemic
                            Therapy (MST)
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_15" name="cb_15" className='add-only' value="1" /> Psychotherapy
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>LOCUS/CALOCUS Score at discharge:</span>
                    <input type='text' id="txt_16" name="txt_16" className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Reason for Discharge:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rb_17_1" name="rb_17" className='add-only' value="1" /> Successfully
                            completed program
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rb_17_2" name="rb_17" className='add-only' value="2" /> Referred/Transferred
                            to a more intense level of care
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rb_17_3" name="rb_17" className='add-only' value="3" /> Referred/
                            Transferred to a less intense level of care
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rb_17_4" name="rb_17" className='add-only' value="4" /> Left Voluntarily
                            by choice
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rb_17_5" name="rb_17" className='add-only' value="5" /> Lack of progress,
                            program initiated
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rb_17_6" name="rb_17" className='add-only' value="6" /> Lack of progress,
                            participant initiated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rb_17_7" name="rb_17" className='add-only' value="7" /> Program rule
                            violation
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rb_17_8" name="rb_17" className='add-only' value="8" /> Medical Problem,
                            unable to participate
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rb_17_9" name="rb_17" className='add-only' value="9" /> Legal
                            Problem/Situation, unable to participate
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rb_17_10" name="rb_17" className='add-only' value="10" /> Change in
                            geographic/living location
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rb_17_11" className='add-only' value="11" /> Other:
                            &nbsp;
                            <input type='text' id="txt_18" name="txt_18" className='add-only w-250 custom-add-only' />
                        </td> 
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Status of Person at Dishcharge:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rb_19_1" name="rb_19" className='add-only' value="1" /> Presenting
                            Condition greatly improved
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rb_19_2" name="rb_19" className='add-only' value="2" /> Presenting
                            Condition moderately improved
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rb_19_3" name="rb_19" className='add-only' value="3" /> Presenting
                            Condition slightly improved
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rb_19_4" name="rb_19" className='add-only' value="4" /> Presenting
                            Condition not improved
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rb_19_5" name="rb_19" className='add-only' value="5" /> Presenting
                            Condition has worsened
                        </td>
                        <td className='w-375'>&nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Recommended Support Systems and Services that will
                                support continued recovery or well-being
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <strong>Person/Agency</strong>
                        </td>
                        <td className='w-150'>
                            <strong>Location/Address</strong>
                        </td>
                        <td className='w-150'>
                            <strong>Phone Number</strong>
                        </td>
                        <td className='w-150'>
                            <strong>Contact Person</strong>
                        </td>
                        <td className='w-150'>
                            <strong>First (or next) Appointment
                                (time and date, if known)
                            </strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id="txt_20" name="txt_20" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id="txt_21" name="txt_21" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id="txt_22" name="txt_22" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id="txt_23" name="txt_23" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id="txt_24" name="txt_24" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id="txt_25" name="txt_25" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id="txt_26" name="txt_26" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id="txt_27" name="txt_27" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id="txt_28" name="txt_28" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id="txt_29" name="txt_29" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id="txt_30" name="txt_30" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id="txt_31" name="txt_31" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id="txt_32" name="txt_32" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id="txt_33" name="txt_33" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id="txt_34" name="txt_34" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Medications at discharge if applicable:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <strong>Type</strong>
                        </td>
                        <td className='w-250'>
                            <strong>Strength</strong>
                        </td>
                        <td className='w-250'>
                            <strong>Dosage</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id="txt_35" name="txt_35" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txt_36" name="txt_36" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txt_37" name="txt_37" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id="txt_38" name="txt_38" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txt_39" name="txt_39" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txt_40" name="txt_40" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id="txt_41" name="txt_41" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txt_42" name="txt_42" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txt_43" name="txt_43" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Primary Contact Person:</span>
                            <input type="text" id="txt_44" name="txt_44" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone:</span>
                            <input type="text" id="txt_45" name="txt_45" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Relationship to Client:</span>
                            <input type="text" id="txt_46" name="txt_46" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Primary Address:</span>
                            <input type="text" id="txt_47" name="txt_47" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    Follow- up with you and/or your family after discharge may include contact from our
                    administrative or program staff at Life Changing Solutions, LLC. In the event we are unable to
                    contact anyone at your current residence, please provide us with a second number and address.
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Secondary Contact Person:</span>

                            <input type="text" id="txt_48" name="txt_48" className='add-only' />
                        </td>
                        <td className='w-375'>

                            <span className='eleHeader'>Phone:</span>
                            <input type="text" id="txt_49" name="txt_49" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>

                            <span className='eleHeader'>Relationship to Client:</span>
                            <input type="text" id="txt_50" name="txt_50" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Secondary Address:</span>
                            <input type="text" id="txt_51" name="txt_51" className='add-only' />
                        </td>
                    </tr>
                </table>



            </div>
        </form>

    )
}











